// menu-items/index.js
import { dashboard, myDashboard } from "./dashboard";
import { employeeSection, managerReportsSection, projectManagerSection } from "./other";
import { employeeLeaveSection, manageLeaveSection, personalLeaveSection } from "./leaves";
import employees from "./employees";
import hrStaff from "./hrStaff";
import recruitment from "./recruitment";
import policies from "./officePolicies";
// import request from "./request";
import event from "./event";
import timesheetSection from "./timesheet";
import request from "./Request";
import devSection from "./dev";

const getMenuItems = () => {
  const userRole = localStorage.getItem("userRole");
  const userPosition = localStorage.getItem("userPosition");
  const isProjectManager = ["EMPLOYEE", "MANAGER", "HR"].includes(userRole) && userPosition === "Project Manager";
  let items = [];

  if (userRole === "DEV") {
    items = [
      dashboard,
      myDashboard,
      devSection,
      // timesheetSection,
      employeeSection,
      hrStaff,
      employees,
      recruitment,
      event,
      employeeLeaveSection,
      manageLeaveSection,
      request,
      projectManagerSection,
      managerReportsSection,
      policies,
    ];
  } else if (
    userRole === "MANAGER" ||
    userRole === "HR"
  ) {
    items = [
      dashboard,
      // timesheetSection,
      hrStaff,
      employees,
      recruitment,
      event,
      manageLeaveSection,
      personalLeaveSection,
      request,
      managerReportsSection,
      policies,
    ];
  } else if (userRole === "DIRECTOR") {
    items = [
      dashboard,
      // timesheetSection,
      hrStaff,
      employees,
      recruitment,
      event,
      manageLeaveSection,
      request,
      managerReportsSection,
      policies,
    ];
  } else if (userRole === "EMPLOYEE") {
    if (isProjectManager) {
      items = [
        myDashboard,
        // timesheetSection,
        projectManagerSection,
        hrStaff,
        employeeSection,
        event,
        employeeLeaveSection,
        policies,
      ];
    } else {
      items = [
        myDashboard,
        timesheetSection,
        hrStaff,
        employeeSection,
        event,
        employeeLeaveSection,
        policies,
      ];
    }
  }

  return { items }; // ✅ always return an object with items
};

export default getMenuItems; // ✅ default export

// //import dashboard from './dashboard';
// import pages from './pages';
// import utilities from './utilities';
// import employees from './employees';
// import recruitment from './recruitment';
// import hrStaff from './hrStaff';
// import policies from './officePolicies';

// // Import the two separate sections
// import { employeeSection, managerReportsSection } from './other';
// import {employeeLeaveSection, manageLeaveSection } from './leaves';
// import {dashboard, myDashboard} from './dashboard';

// import request from './request';

// // ==============================|| MENU ITEMS ||============================== //

// const userRole = localStorage.getItem('userRole');

// let items = [];

// if (userRole === 'DEV') {
//   items = items.concat([ dashboard, myDashboard,  employeeSection, hrStaff, employees, recruitment, employeeLeaveSection, manageLeaveSection, request,
//   managerReportsSection,   // ← "Manager Reports"
//   policies]);
//   //employeeSection, policies, pages, utilities]);
// } else if (userRole === 'MANAGER' || userRole === 'HR' || userRole === 'DIRECTOR') {
//   items = items.concat([dashboard, hrStaff, employees, recruitment, manageLeaveSection, request, managerReportsSection, policies]);
// } else if (userRole === 'EMPLOYEE') {
//   items = items.concat([myDashboard, hrStaff, employeeSection, employeeLeaveSection, policies]);
// }

// // Export the menu structure as an object with an `items` array
// const menuItems = {
//   items
// };

// export default menuItems;
